import { Badge } from "@/components/ui/others/Badges";
import useLeadPipeline from "@/features/leads/hook/useLeadPipeline";
import { useActiveDataMutation } from "@/features/leads/hook/useActiveDataMutation";
import { CheckCircle2 } from "lucide-react";

export default function StageSection({ curStage }: { curStage: any }) {
  const { pipeline } = useLeadPipeline();
  const { activeData, isChildActive } = useActiveDataMutation();

  const displayStage =
    isChildActive && activeData?.stage ? activeData.stage : curStage;

  if (!pipeline?.length || !displayStage) return null;

  return (
    <div className="w-full overflow-x-auto -ml-2">
      <div className="flex gap-1 items-center min-w-max">
        {pipeline.map((stageItem: any) => {
          const isCompleted = stageItem.order < displayStage.order;
          const isCurrent = stageItem.order === displayStage.order;

          return (
            <Badge
              key={stageItem.id}
              className={`flex gap-1 items-center justify-center rounded-[10px]
                px-3 py-[5px] h-8 min-w-[120px]
                ${
                  isCompleted
                    ? "bg-[#46a580] text-white"
                    : isCurrent
                      ? "bg-[#46a580] text-white"
                      : "bg-[#f7f7f7] text-[#9ba3a0]"
                }`}
            >
              {isCompleted && (
                <CheckCircle2 className="size-4" strokeWidth={2} />
              )}

              <span className="text-[14px] font-medium tracking-[-0.56px] leading-none whitespace-nowrap">
                {stageItem.name}
              </span>
            </Badge>
          );
        })}
      </div>
    </div>
  );
}
